import React from "react";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const Search = (props) => {
  const { value, onChange, onFocus, placeholder, autoFocus, ref, className } = props;
  return (
    <div className={`search ${className}`}>
      <div className="search-icon">
        <SearchRoundedIcon />
      </div>
      <input
        ref={ref}
        type="text"
        placeholder={placeholder ? placeholder : "Search..."}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        autoFocus={autoFocus}
      />
    </div>
  );
};

export default Search;
